























































import { Vue, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import moment from "moment";
import RecogForm from "../components/forms/RecogForm.vue";
import RecognitionAnalyticsStore from "../store/recognition-analytics.store";
import RecogByHeaderFieldChart from "../components/charts/RecognitionByHeaderField.vue";
import RecogBySupplierChart from "../components/charts/RecognitionBySupplier.vue";
import RecogTimelineChart from "../components/charts/RecognitionTimeline.vue";
import DataSnapshot from "../components/data/DataSnapshot.vue";

@Component({
  components: {
    "recog-form": RecogForm,
    "data-snapshot": DataSnapshot,
    "recog-timeline-chart": RecogTimelineChart,
    "recog-header-field-chart": RecogByHeaderFieldChart,
    "recog-supplier-chart": RecogBySupplierChart
  }
})
export default class Recognition extends Vue {
  private timelineChartLoading = false;
  private headerFieldChartLoading = false;
  private supplierChartLoading = false;

  private recognitionAnalyticsStore: RecognitionAnalyticsStore = getModule(
    RecognitionAnalyticsStore,
    this.$store
  );

  private todayDate = moment()
    .format()
    .toString()
    .substring(0, 10);

  private get dateRange() {
    return this.recognitionAnalyticsStore.getDateRange;
  }

  private get selectedSite() {
    return this.recognitionAnalyticsStore.getSelectedSite;
  }

  private get averageOverallRecogRate() {
    return this.recognitionAnalyticsStore.getAverageOverallRecogRate;
  }

  private get invoicesAnalyzed() {
    return this.recognitionAnalyticsStore.getInvoicesAnalyzed;
  }

  private get numberOfSuppliers() {
    return this.recognitionAnalyticsStore.getNumberOfSuppliers;
  }

  async handleSelectionChange(selection: {
    startDate: string;
    endDate: string;
    site: string;
    includeValidationServices: boolean;
  }) {
    this.timelineChartLoading = true;
    this.headerFieldChartLoading = true;
    this.supplierChartLoading = true;
    const dateRange: { startDate: string; endDate: string } = {
      startDate: selection.startDate,
      endDate: selection.endDate
    };
    this.recognitionAnalyticsStore.updateDateRange(dateRange);
    this.recognitionAnalyticsStore.updateSelectedSite(selection.site);
    this.recognitionAnalyticsStore.updateIncludeVsInRecogRates(
      selection.includeValidationServices
    );
    this.recognitionAnalyticsStore.clickRecogSearchButton();
  }

  async created() {
    if (this.selectedSite !== "" && this.averageOverallRecogRate === "0%") {
      this.timelineChartLoading = true;
      this.headerFieldChartLoading = true;
      this.supplierChartLoading = true;
    }
  }

  timelineChartLoaded() {
    this.timelineChartLoading = false;
  }

  headerFieldChartLoaded() {
    this.headerFieldChartLoading = false;
  }

  supplierChartLoaded() {
    this.supplierChartLoading = false;
  }
}
